import * as React from 'react';
import { Product } from '~/Api/Product';
import { BgMaxPrice } from '~/Api/User/ProductGroup/BgMaxPrice';

export const ProductProvider: React.FunctionComponent<
	React.PropsWithChildren<{
		bgMaxPrice: BgMaxPrice | null;
		id: string;
		children(product: Product | null): React.ReactNode;
	}>
> = ({ bgMaxPrice, id, children }) => {
	const product = React.useMemo(
		() => bgMaxPrice?.products.find((candidate) => candidate.product.id === id)?.product ?? null,
		[bgMaxPrice, id]
	);
	return <>{children(product)}</>;
};

ProductProvider.displayName = 'BgMaxPrice.ProductProvider';
